// extracted by mini-css-extract-plugin
export default {"departments":"qG-z","departmentHeading":"rG-z","departmentSection":"sG-z","departmentName":"tG-z","departmentLink":"uG-z","expandIcon":"vG-z"};